import { render, staticRenderFns } from "./CoverageUpdate.vue?vue&type=template&id=2168fd80"
import script from "./CoverageUpdate.vue?vue&type=script&lang=js"
export * from "./CoverageUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports